import typeDefs from "./typeDefs.graphql";
import createResolvers from "./resolvers";

export default config => ({
  typeDefs,
  resolvers: createResolvers(config)
});
